import React from "react";
import { database } from '../../firebaseConfig';
import { doc, deleteDoc, updateDoc } from "firebase/firestore";
import AdminDashboard from '../../UserPanel/Shared/AdminDashboard/AdminDashboard';
import "./ManageComment.css"

function ManageComment(props) {
    ///////////////////////////////////////////////////////////////////
    const handleDelete = (id) => {
        deleteDoc(doc(database, "comments", id)).then(() => {
            alert("comment deleted")
        })
    }
    ///////////////////////////////////////////////////////////////////

    const handleUpdate = (id) => {
        updateDoc(doc(database, "comments", id), {
            approved: true
        }).then(() => {
            alert("this comment is approved")
        })
    }

    return (
        < div className="commentBack">
            <AdminDashboard></AdminDashboard>

            {
                props.comments.map((item) => {

                    return (

                        <div className="comments container mt-5" key={(item.id)}>

                            <h2 className="my-4">{(item.name)}</h2>

                            <h6 className="my-4">{(item.comment)}</h6>

                            <button className="btn btn-danger m-1" onClick={() => handleDelete(item.id)}>Delete</button>


                            {!(item.approved) ? <button className="btn btn-success ,m-1" onClick={() => handleUpdate(item.id)}>Approve</button> : ''}


                        </div>)
                })
            }
        </div >
    )
}

export default ManageComment;
